'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _map2 = _interopRequireDefault(require("lodash/map"));

var _take2 = _interopRequireDefault(require("lodash/take"));

var _drop2 = _interopRequireDefault(require("lodash/drop"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));

var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _cell = _interopRequireDefault(require("./cell"));

var _default_row_renderer = _interopRequireDefault(require("./default_row_renderer"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultCellRenderer = function defaultCellRenderer(_ref) {
  var rowData = _ref.rowData,
      dataKey = _ref.dataKey;
  return (0, _get2["default"])(rowData, dataKey, '');
};

var Row =
/*#__PURE__*/
function (_Component) {
  _inherits(Row, _Component);

  function Row() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Row);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Row)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "renderColumn", function (columnComponent, columnIndex) {
      var _this$props = _this.props,
          rowData = _this$props.rowData,
          rowIndex = _this$props.rowIndex;
      var column = columnComponent.props;

      var cellClassNames = _this.getCellClassNames(column);

      var cellRenderer = (0, _isFunction2["default"])(column.cellRenderer) ? column.cellRenderer : defaultCellRenderer;
      var cellData = rowData ? cellRenderer({
        rowData: rowData,
        rowIndex: rowIndex,
        dataKey: column.dataKey
      }) : '';
      return _react["default"].createElement(_cell["default"], {
        key: column.dataKey,
        columnIndex: columnIndex,
        data: cellData,
        className: cellClassNames
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderColumns", function (columns, scrolledColumns, maxVisibleColumns) {
      if (columns.length === 0) {
        return _react["default"].createElement("div", {
          className: "table-list-column"
        }, "No column data");
      }

      var numVisibleColumns = maxVisibleColumns ? maxVisibleColumns : columns.length;
      var ret = (0, _drop2["default"])(columns, scrolledColumns + 1); // first column is always visible

      ret = (0, _take2["default"])(ret, numVisibleColumns);
      ret = (0, _map2["default"])(ret, _this.renderColumn);
      ret.unshift(_this.renderColumn(columns[0], 0));
      return ret;
    });

    return _this;
  }

  _createClass(Row, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return this.props.rowIndex !== nextProps.rowIndex || this.props.sortBy !== nextProps.sortBy || this.props.rowClassName !== nextProps.rowClassName || this.props.scrolledColumns !== nextProps.scrolledColumns || this.props.maxVisibleColumns !== nextProps.maxVisibleColumns || this.props.loading !== nextProps.loading || !(0, _isEqual2["default"])(this.props.rowData, nextProps.rowData);
    }
  }, {
    key: "getCellClassNames",
    value: function getCellClassNames(column) {
      var _this$props2 = this.props,
          rowData = _this$props2.rowData,
          rowIndex = _this$props2.rowIndex,
          sortBy = _this$props2.sortBy;
      var dataKey = column.dataKey,
          className = column.className;
      var isSorting = sortBy === column.dataKey;
      var columnClassName = (0, _isFunction2["default"])(className) ? className({
        rowIndex: rowIndex,
        rowData: rowData
      }) : className;
      var cellClassNames = (0, _classnames["default"])('table-list-column', dataKey, {
        sorting: isSorting && rowData
      }, {
        loading: (0, _isEmpty2["default"])(rowData)
      }, columnClassName);
      return cellClassNames;
    }
  }, {
    key: "renderWithData",
    value: function renderWithData(content, rowStyle) {
      var _this$props3 = this.props,
          rowData = _this$props3.rowData,
          rowIndex = _this$props3.rowIndex,
          rowClassName = _this$props3.rowClassName,
          rowRenderer = _this$props3.rowRenderer,
          columns = _this$props3.columns,
          scrolledColumns = _this$props3.scrolledColumns,
          maxVisibleColumns = _this$props3.maxVisibleColumns,
          onClick = _this$props3.onClick,
          onDoubleClick = _this$props3.onDoubleClick,
          onMouseOver = _this$props3.onMouseOver,
          onMouseOut = _this$props3.onMouseOut,
          onMouseEnter = _this$props3.onMouseEnter,
          onMouseLeave = _this$props3.onMouseLeave;
      var canScrollRight = scrolledColumns + maxVisibleColumns < columns.length;
      var className = (0, _classnames["default"])('table-list-item', {
        scrolled: scrolledColumns > 0,
        canScrollRight: canScrollRight
      }, rowClassName);
      return rowRenderer({
        onClick: onClick,
        rowClassName: rowClassName,
        onDoubleClick: onDoubleClick,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        className: className,
        rowData: rowData,
        style: rowStyle,
        index: rowIndex,
        columns: content
      });
    }
  }, {
    key: "renderWithoutData",
    value: function renderWithoutData(content, rowStyle) {
      var _this$props4 = this.props,
          rowIndex = _this$props4.rowIndex,
          rowClassName = _this$props4.rowClassName;
      var className = (0, _classnames["default"])('table-list-item', 'loading', rowClassName);
      return (0, _default_row_renderer["default"])({
        className: className,
        style: rowStyle,
        index: rowIndex,
        columns: content
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          loading = _this$props5.loading,
          rowHeight = _this$props5.rowHeight,
          rowIndex = _this$props5.rowIndex,
          columns = _this$props5.columns,
          scrolledColumns = _this$props5.scrolledColumns,
          maxVisibleColumns = _this$props5.maxVisibleColumns;
      var translation = "translate3d(0, ".concat(rowIndex * rowHeight, "px, 0)");
      var rowStyle = {
        transform: translation,
        WebkitTransform: translation,
        msTransform: translation,
        height: rowHeight
      };
      var content = this.renderColumns(columns, scrolledColumns, maxVisibleColumns);

      if (loading) {
        return this.renderWithoutData(content, rowStyle);
      } else {
        return this.renderWithData(content, rowStyle);
      }
    }
  }]);

  return Row;
}(_react.Component);

_defineProperty(Row, "propTypes", {
  loading: _propTypes.PropTypes.bool.isRequired,
  rowRenderer: _propTypes.PropTypes.func.isRequired,
  columns: _propTypes.PropTypes.array.isRequired,
  rowIndex: _propTypes.PropTypes.number.isRequired,
  rowHeight: _propTypes.PropTypes.number.isRequired,
  rowData: _propTypes.PropTypes.object,
  sortBy: _propTypes.PropTypes.string,
  maxVisibleColumns: _propTypes.PropTypes.number,
  rowClassName: _propTypes.PropTypes.string,
  onClick: _propTypes.PropTypes.func,
  onDoubleClick: _propTypes.PropTypes.func,
  onMouseOver: _propTypes.PropTypes.func,
  onMouseOut: _propTypes.PropTypes.func,
  onMouseEnter: _propTypes.PropTypes.func,
  onMouseLeave: _propTypes.PropTypes.func
});

_defineProperty(Row, "defaultProps", {
  loading: false,
  scrolledColumns: 0
});

var _default = Row;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@rapiddot/react-virtual-list/lib/table/row.js
// module id = 478
// module chunks = 0